import React from 'react';
export const CHECKOUT_URL = 'https://vitalyforms.com/cart/51134549754076:1';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
}
export function PremiumButton({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={onClick} className={`inline-block bg-peach text-forest py-4 px-8 rounded-full font-semibold text-lg tracking-wide transition-all duration-300 animate-pulse-glow hover:-translate-y-1 hover:scale-105 text-center cursor-pointer ${className}`} {...props} data-id="element-483">
      {children}
    </a>;
}